import moment from 'moment';
import { TIME_DELTA_REGEX } from '@src/constants';
import { isNaN, isNil } from 'lodash';

const formatAudioTime = (numberOfSeconds) => {
  let minutes = Math.floor(numberOfSeconds / 60);
  let seconds = Math.floor(numberOfSeconds) - 60 * minutes;

  minutes = minutes.toString().padStart(2, '0');
  seconds = seconds.toString().padStart(2, '0');

  return `${minutes}:${seconds}`;
};

const isSameToday = (date) => moment().isSame(date, 'day');

// Convert time delta format (hh:mm:ss,SSS) to milliseconds
const convertTimeDeltaToMillis = (timeDelta = '') => {
  const [hour, minute, secondPart] = timeDelta.split(':');
  const second = parseFloat(secondPart.replace(',', '.'));

  return (
    parseInt(hour, 10) * 3600 * 1000 +
    parseInt(minute, 10) * 60 * 1000 +
    second * 1000
  );
};

const isValidTimeDelta = (timeDelta) => {
  const res = TIME_DELTA_REGEX.test(timeDelta);
  return res;
};

const convertSecondsToHMS = (seconds) => {
  if (isNil(seconds) || isNaN(seconds)) return '';

  let hours = Math.floor(seconds / 3600);
  let minutes = Math.floor((seconds % 3600) / 60);
  let remainingSeconds = Math.ceil(seconds % 60);

  // Add leading zeros if necessary
  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  remainingSeconds =
    remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;

  return `${hours}:${minutes}:${remainingSeconds}`;
};

// convert seconds to hh:mm:ss,SSS
//
// Rounds to whole milliseconds FIRST, then splits that into h/m/s/ms. Rounding
// the fractional part on its own instead lets it come out as 1000 — any input
// from x.9995 up — which produced a field the format has no room for and that
// reads back as a tenth of a second:
//   5.9996 -> "00:00:05,1000" -> 5.1   (0.9s adrift)
// Timeline drags feed this raw pixel-derived floats, so the value did land there.
const convertSecondsToSubtitleTime = (seconds) => {
  if (isNil(seconds) || isNaN(seconds)) return '';

  const totalMilliseconds = Math.round(seconds * 1000);
  const milliseconds = totalMilliseconds % 1000;
  const totalSeconds = (totalMilliseconds - milliseconds) / 1000;

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds / 60) % 60;
  const remainingSeconds = totalSeconds % 60;

  return [
    String(hours).padStart(2, '0'),
    String(minutes).padStart(2, '0'),
    `${String(remainingSeconds).padStart(2, '0')},${String(
      milliseconds,
    ).padStart(3, '0')}`,
  ].join(':');
};

// Convert format hh:mm:ss,miliseconds to seconds
const convertSubtitleTimeToSeconds = (time) => {
  const [hour, minute, secondPart] = time.split(':');
  const second = parseFloat(secondPart.replace(',', '.'));

  return parseInt(hour, 10) * 3600 + parseInt(minute, 10) * 60 + second;
};

export {
  formatAudioTime,
  isSameToday,
  convertTimeDeltaToMillis,
  isValidTimeDelta,
  convertSecondsToHMS,
  convertSubtitleTimeToSeconds,
  convertSecondsToSubtitleTime,
};
